import React, { Fragment, forwardRef } from 'react';
import cx from 'classnames';
import { CLASS_PAGE } from '../../css-api';
import UbaFooter from '../uba/footer';

const Page = forwardRef(({ id, alignSelf, classNames, children, styles }, ref) => {
  return (
      <Fragment>
    <main
      id={id}
      ref={ref}
      className={cx(CLASS_PAGE, classNames)}
      style={{ flexGrow: 1, alignSelf, ...styles }}
    >
      {children}
    </main>
      <UbaFooter></UbaFooter>
      </Fragment>
  );
});

export default Page;
